import React from "react";

import ManagedPortalHome from "screens/ManagedPortalHome";

export default function MVUEssentialsHome() {
    return <ManagedPortalHome portal="essentials" />;
}
